import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,_vm._b({attrs:{"color":_vm.$attrs.color,"top":"","maxWidth":_vm.tooltipMaxWidth,"contentClass":"edn-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon,_vm._g(_vm._b({class:_vm.getActivatorClass,staticStyle:{"cursor":"pointer"},attrs:{"color":_vm.iconColor,"size":_vm.iconSize,"small":_vm.iconSmall}},'v-icon',_vm.$attrs,false),on),[_vm._v("mdi-information")])]}}])},'v-tooltip',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }